var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    { attrs: { trigger: "click" }, on: { command: _vm.changeLang } },
    [
      _c("span", { staticClass: "el-dropdown-link flex-level cpointer" }, [
        _c("img", {
          staticClass: "pr-2",
          attrs: {
            src:
              "/ressources/public/img/flags/lang/" + _vm.currentLang.id + ".png"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.currentLang.label))]),
        _vm._v(" "),
        _c("i", { staticClass: "icon-chevron-bottom ml-3 gray-60" })
      ]),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        _vm._l(_vm.languages, function(lang, langKey) {
          return _c(
            "el-dropdown-item",
            {
              key: langKey,
              staticClass: "flex-level",
              attrs: { command: lang.id }
            },
            [
              _c("img", {
                staticClass: "pr-2",
                attrs: {
                  src: "/ressources/public/img/flags/lang/" + lang.id + ".png"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(lang.label))])
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }